<template>
    <li>
        <i v-bind:class="iconClasses" v-on:click="expand"></i>
        <span class="treeitem" @click="handleClick(treeitem)" v-bind:class="selectedClasses">
           {{ itemText() }}
        </span>
        <span class="trail" @click="handleClick(treeitem)">
           {{ itemTrail() }}
        </span>
        <a v-if="showAppointLink" class="fas fa-link icon ml-corp" @click.prevent="handleLink(treeitem)" v-tooltip:Right="'New Appointment'"></a>         
        <ul class="treeitems" v-if="treeitem.children && treeitem.children.length > 0" v-show="expanded">           
            <tree-item 
                v-for="child in treeitem.children" 
                :key="ticks.toString() + child.agentNumber" 
                :treeitem="child" 
                :selected="selected"
                :handle-click="handleClick"
                :handle-link="handleLink"
                :handle-fetch="handleFetch"
                :pageSize="pageSize"
                :enableAppointLink="enableAppointLink"
            ></tree-item>
            <li v-if="showMore()"><a class="treeitem" href="#" @click.prevent="handleFetch(treeitem)">(more)</a></li>
        </ul>
        
    </li>
</template>


<script>
      
export default {
    name: "tree-item",
    props: { 
        'treeitem': Object, 
        'selected': Object,
        handleClick: Function,
        handleLink: Function,
        handleFetch: Function,
        'pageSize': Number,
        'enableAppointLink': Boolean
    },   
    data() {
        return {
            ticks: new Date().getTime(),
            expandedValue: false,
            expandedChanged: false
        }
    }, 
    computed: {
        iconClasses: function() {
            return {
                'dashh': this.treeitem.childCount == 0,
                'fas fa-angle-down': this.treeitem.childCount > 0 && this.expanded,
                'fas fa-angle-right': this.treeitem.childCount > 0 && !this.expanded
            }
        },
        selectedClasses: function() {
           let isSelected = (this.selected && this.treeitem.agentNumber == this.selected.agentNumber)
           return {
              'is-selected': isSelected
           }
        },
        showAppointLink: function() {
           return this.enableAppointLink && this.treeitem.treeLevel >= this.selected.treeLevel
        },
        expanded: {
            get: function () {
               if (this.expandedChanged) 
                  return this.expandedValue
               if (this.selected &&  this.treeitem.treeLevel <= this.selected.treeLevel)
                  return true
               return false;
            },
            set: function (newValue) {
               this.expandedValue = newValue
               this.expandedChanged = true
            }
        }
    },
    watch: {
        treeitem: {
            handler: function(itm) {
                this.ticks = new Date().getTime()
                this.$forceUpdate();
            },
            immediate: true
        }
    },
    mounted() {

    },
    methods: {
        expand() {
            // Do we need to grab more data?
            if (this.treeitem.childCount > 0 && this.treeitem.childPage == 0 && this.treeitem.treeLevel > -1) {
               this.handleFetch(this.treeitem)
            }
            this.expanded = !this.expanded;
        },
        itemExists() {
            return this.treeitem != null && this.treeitem != undefined
        },
        itemText() {
            let nm = ''
            if (this.treeitem.lastName == null) { //use company name
               //fix the crappy space
               if (this.treeitem.companyName != null &&
                  this.treeitem.companyName.length > 26  && 
                  this.treeitem.companyName[25] == ' ' &&
                  this.treeitem.companyName[24] != ' ' &&
                  this.treeitem.companyName[26] != ' '
               ) {
                  nm = this.treeitem.companyName.substr(0,25) + this.treeitem.companyName.substr(26)
               } else {
                  nm = this.treeitem.companyName
               }
            } else {
               nm = this.treeitem.lastName.trim() + ', ' + this.treeitem.firstName.trim()
            }
            let lvl = parseInt(this.treeitem.hierarchyLevel)
            if (isNaN(lvl)) { 
               lvl = 'Unknown'   
            }
            let line = `${nm} (${this.treeitem.blockNumber}-${this.treeitem.agentNumber})` + this.showLevelLabel(this.treeitem,lvl)
            return nm
        },
        itemTrail() {
            let lvl = parseInt(this.treeitem.hierarchyLevel)
            if (isNaN(lvl)) { 
               lvl = 'Unknown'   
            }
            let line = `${this.treeitem.agentNumber})` + this.showLevelLabel(this.treeitem,lvl)
            return line
        },
        showLevelLabel(tItem, lvl) {
            if (tItem.showLevel != null && tItem.showLevel != undefined && tItem.showLevel == true) {
               return ` [Level ${lvl}]`
            } else {
               return ''
            }
        },
        showMore() {
            let more = false
            let t = this.treeitem
            // dont allow fetch more link on nodes above selected agent
            if (t.treeLevel > -1) {
               let lastPage = Math.floor((t.childCount % this.pageSize == 0 ? 0 : 1) + t.childCount / this.pageSize)
               more = t.childCount > 0 && (t.childPage == 0 || t.childPage < lastPage)
            }
            return more
        }
    }
}
</script>

<style scoped lang="scss">
@import '../assets/css/colors.scss';
ul.treeitems li {
    padding: 0 4px;
}
ul.treeitems li i {
    padding-right: 8px;
}
ul.treeitems li > span {
    cursor: pointer;
    display:inline-block
}
.treeitem {
    border: none;
    padding: 4px;
}
.is-selected {
    background-color: $corp-orange;
}
ul.treeitems {
    padding: 0 1.5rem;
    margin: 0;
    box-sizing: border-box;
    width: 100%;
    list-style: none;
    border: none;
}
div.folder-empty {
  color: #000;
  opacity: 0.5
}
.dashh::after {
   content: '•';
}
.trail {
   color: $corp-color;
   padding-left:12px;
}
a.treeitem, a.treeitem:visited {
   color: $corp-color;
}
a.treeitem:hover {
   font-weight: bold;
   color: $corp-purple;
}
.icon {
   padding-left: 5px;
   padding-right: 5px;
   text-decoration: none;
}
</style>